export const sectors = [
  {
    name: 'CH',
    label: "Children's Home",
  },
  {
    name: 'NH',
    label: 'Nursing Home',
  },
  {
    name: 'CaH',
    label: 'Care Home',
  },
  {
    name: 'HC',
    label: 'Home Care',
  },
  {
    name: 'SL',
    label: 'Supported Living',
  },
  {
    name: 'H',
    label: 'Hospital',
  },
];

export const roles = [
  {
    name: 'community-support-worker',
    label: 'Community Support Worker',
    tokens: 1,
    sectors: ['HC'],
  },
  {
    name: 'support-worker',
    label: 'Support Worker',
    tokens: 1,
    sectors: ['SL'],
  },
  {
    name: 'senior-support-worker',
    label: 'Senior Support Worker',
    tokens: 1,
    sectors: ['HC', 'SL'],
  },
  {
    name: 'care-coordinator',
    label: 'Care Co-ordinator/Rota Planner',
    tokens: 1,
    sectors: ['HC'],
  },
  {
    name: 'rn-children',
    label: 'RN Children',
    tokens: 3,
    sectors: ['CH', 'H'],
  },
  {
    name: 'rgn-nurse',
    label: 'RGN Nurse',
    tokens: 3,
    sectors: ['NH', 'H'],
  },
  {
    name: 'rmn-nurse',
    label: 'RMN Nurse',
    tokens: 3,
    sectors: ['CH', 'H'],
  },
  {
    name: 'residential-support-worker',
    label: 'Residential Support Worker',
    tokens: 1,
    sectors: ['CH'],
  },
  {
    name: 'residential-senior-support-worker',
    label: 'Residential Senior Support Worker/Team Leader',
    tokens: 1,
    sectors: ['CH'],
  },
  {
    name: 'deputy-manager',
    label: 'Deputy Manager',
    tokens: 2,
    sectors: ['CH', 'H', 'CaH', 'NH'],
  },
  {
    name: 'manager',
    label: 'Manager',
    tokens: 3,
    sectors: ['CH', 'H', 'CaH', 'NH', 'SL'],
  },
  {
    name: 'domestic-housekeeper',
    label: 'Domestic/Housekeeper',
    tokens: 1,
    sectors: ['CH', 'H', 'CaH', 'NH'],
  },
  {
    name: 'carer-care',
    label: 'Carer - Care',
    tokens: 1,
    sectors: ['H', 'CaH', 'NH'],
  },
  {
    name: 'senior-carer',
    label: 'Senior Carer',
    tokens: 1,
    sectors: ['H', 'CaH', 'NH'],
  },
  {
    name: 'unit-manager',
    label: 'Unit Manager',
    tokens: 2,
    sectors: ['CaH', 'NH'],
  },
  {
    name: 'activities-coordinator',
    label: 'Activities Coordinator',
    tokens: 1,
    sectors: ['CaH', 'NH'],
  },
  {
    name: 'catering-assistant',
    label: 'Catering Assistant',
    tokens: 1,
    sectors: ['CH', 'H', 'CaH', 'NH'],
  },
  {
    name: 'cook-chef',
    label: 'Cook/Chef',
    tokens: 2,
    sectors: ['CH', 'H', 'CaH', 'NH'],
  },
  {
    name: 'receptionist-admin',
    label: 'Receptionist/Admin',
    tokens: 1,
    sectors: ['CaH', 'NH', 'H'],
  },
];

export const orgTypes = [
  {
    name: 'privateLtd',
    label: 'Private LTD',
  },
  {
    name: 'plc',
    label: 'PLC',
  },
  {
    name: 'soleTrader',
    label: 'Sole Trader',
  },
  {
    name: 'charity',
    label: 'Charity',
  },
  {
    name: 'notForProfit',
    label: 'Not for Profit',
  },
];

export const RolesBySector = (sector) => {
  return roles.filter(({ sectors: arr }) => {
    if (sector == null) return true;
    const s = new Set(arr);
    return s.has(sector);
  });
};

export const GetTokensByRole = (arr) => {
  if (arr.length < 1) return 1;

  const s = new Set(arr.map((item) => item.role));
  const filteredRoles = roles.filter((item) => {
    return s.has(item.name);
  });

  if (filteredRoles.length < 1) return 1;

  return filteredRoles.sort((a, b) => {
    return b.tokens - a.tokens;
  })[0].tokens;
};
